import React, { useCallback, useContext, useEffect } from 'react';
import { CampaignAndDateSelector, CampaignSaveData, PluginScenarios } from '@bingads-webui/ads-copilot-ui';
import { I18nContext, I18nModel } from '@bingads-webui/copilot-i18n';
import { type ILogger } from '@bingads-webui-react/msa-copilot-common';

type InsightsMissingParamsProps = {
  getCampaigns: () => Promise<Array<{ name: string, id: string }>>;
  logger?: ILogger,
  onMissingParamsSubmit: (text: string) => void;
  replyToId?: string;
  pluginName?: string;
  cardText?: string;
};

export const InsightsMissingParams: React.FC<InsightsMissingParamsProps> = (props) => {
  const i18n = useContext(I18nContext) as I18nModel;
  const {
    getCampaigns,
    logger,
    onMissingParamsSubmit,
    replyToId,
    pluginName,
    cardText,
  } = props;

  useEffect(() => {
    logger?.trace(`InsightsMissingParams: replyToId: ${replyToId}`);
  }, [logger, replyToId]);

  const onSave = useCallback((_event: any, data: CampaignSaveData) => {
    const tlText = pluginName === PluginScenarios.CampaignFluctuation ? _TL_('Are there fluctuations for my campaign "{{campaignName}}" from {{startDate}} to {{endDate}}')
      : _TL_('Summarize the performance of campaign "{{campaignName}}" from {{startDate}} to {{endDate}}');

    const text = i18n.getString(tlText, {
      campaignName: data?.selectedCampaign.name,
      startDate: data?.startDate ? i18n.formatDate(data.startDate) : undefined,
      endDate: data?.endDate ? i18n.formatDate(data.endDate) : undefined,
    });

    logger?.trace(`InsightsMissingParams: replyToId: ${replyToId} onSave: ${text} plugin: ${pluginName}`);
    onMissingParamsSubmit(text);
  }, [i18n, logger, replyToId]);

  return (
    <CampaignAndDateSelector
      getCampaigns={getCampaigns}
      onSave={onSave}
      showCampaignSelector
      showDateSelector
      cardText={cardText}
    />
  );
};
